import { getConfig } from '../config';
import { fetchData } from '../../shared/utils';

export const handleAdNotLoaded = async (
    targetId: string,
    reason: string,
    data?: any,
) => {
    const config = getConfig();
    await fetchData(config.baseUrl + `/banner-not-loaded?id=${targetId}`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            reason,
            targetId,
            vertical: config.vertical,
            subvertical: config.subvertical,
            pageType: config.pageType,
            deviceType: config.deviceType,
            data: data || undefined,
        }),
    });
};
